import { render, staticRenderFns } from "./AdminMisc.vue?vue&type=template&id=e9628d92&"
import script from "./AdminMisc.vue?vue&type=script&lang=js&"
export * from "./AdminMisc.vue?vue&type=script&lang=js&"
import style0 from "./AdminMisc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports